import React from 'react';
import { MealPlanItemStatus } from '../../interfaces/mealPlan';

interface MealPlanBadgeProps {
    status: MealPlanItemStatus;
    small?: boolean;
}

const MealPlanBadge: React.FC<MealPlanBadgeProps> = ({ status, small }) => {
    if (status === 'none') return null;

    const isIncluded = status === 'included';
    const size = small ? 14 : 18;
    const fontSize = small ? 8 : 10;
    const padding = small ? '1px 4px' : '2px 6px';

    return (
        <span style={{
            display: 'inline-flex', alignItems: 'center', gap: 3,
            fontSize, fontWeight: 600, padding, borderRadius: 10,
            backgroundColor: isIncluded ? '#ECFDF3' : '#FFF6ED',
            color: isIncluded ? '#027A48' : '#B93815',
            whiteSpace: 'nowrap', lineHeight: `${size}px`,
        }}>
            <span style={{
                width: size * 0.5, height: size * 0.5, borderRadius: '50%',
                backgroundColor: isIncluded ? '#12B76A' : '#F79009',
                display: 'inline-block',
            }} />
            {isIncluded ? 'Incl.' : 'Extra'}
        </span>
    );
};

export default MealPlanBadge;
